import { Component, inject, signal } from '@angular/core';
import { LoadPanelService } from '@services/load-panel.service';
import { combineLatest } from 'rxjs';
import { DxLoadPanelComponent } from 'devextreme-angular/ui/load-panel';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ILoadPanelSettings } from '@interfaces/nebula';

@Component({
  selector: 'app-loading-panel',
  templateUrl: './loading-panel.component.html',
  styleUrls: ['./loading-panel.component.scss'],
  imports: [DxLoadPanelComponent]
})
export class LoadingPanelComponent {
  private loadPanelService = inject(LoadPanelService);

  config = signal<ILoadPanelSettings | null>(null);

  constructor() {

    combineLatest([this.loadPanelService.loadPanelState$, this.loadPanelService.loadingPanelActivated$])
      .pipe(takeUntilDestroyed())
      .subscribe(tuple => {
        const config = tuple[0];
        const isActivated = tuple[1];

        if (isActivated && config?.loading) {
          this.config.set(config);
        } else {
          this.config.set(null);
        }
      });
  }
}
